// IDs des produits « lemn de foc » (bois de chauffage) — TVA réduite 11% en Roumanie.
// Source unique de vérité, importée par les écrans facture/devis (+ broker).
export const FIREWOOD_PRODUCT_IDS = [351, 352, 354, 768, 1733];

export function isFirewoodProduct(productId) {
  return FIREWOOD_PRODUCT_IDS.includes(parseInt(productId));
}

/**
 * Une facture est « bois de chauffage » dès qu'UNE de ses lignes l'est.
 *
 * Ne jamais décider depuis `products[0]` : `findOne` trie les produits par id,
 * donc une ligne Transport (idproduct 1) ou Advance (1692) devenait products[0],
 * `isFirewoodProduct(1)` était faux et toute la facture basculait à 21 %. C'est
 * le mécanisme des factures RO 2026 régularisées (voir « XML A ENVOYER/ »).
 *
 * @param {Array} products `operation_data.products`
 * @param {*} extraProductId produit en cours d'ajout, pas encore dans la liste
 */
export function hasFirewoodLine(products, extraProductId = null) {
  if (extraProductId !== null && extraProductId !== undefined && isFirewoodProduct(extraProductId)) {
    return true;
  }
  return (products || []).some(
    (p) => p && p.operations_products && isFirewoodProduct(p.operations_products.idproduct)
  );
}
